var _path, _circle, _path2, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorDoctors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.441,4.188h0c-3.247,0-5.55,3.167-4.55,6.256l3.247,10.028c.527,1.627,1.835,2.881,3.482,3.338h0c3.077.854,6.328.854,9.404,0h0c1.648-.458,2.955-1.711,3.482-3.338l3.247-10.028c1-3.089-1.303-6.256-4.55-6.256h0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34.05,
    cy: 16.043,
    r: 4.296
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m15.322,25.116v8.959c0,3.078,2.495,5.573,5.573,5.573h0c3.078,0,5.573-2.495,5.573-5.573v-3.26c0-2.094,1.697-3.791,3.791-3.791h0c2.094,0,3.791-1.697,3.791-3.791v-2.615"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.277,
    cy: 4.188,
    r: 1.836
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.367,
    cy: 4.188,
    r: 1.836
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorDoctors);
export default __webpack_public_path__ + "static/media/indoor-doctors.98cc92b47bdf07dbd3c0da5281cbf937.svg";
export { ForwardRef as ReactComponent };